import React from "react";
import { useInView } from "react-intersection-observer";

export default function SectionHeading({
  label,
  title,
  subtitle,
  align = "center",
  dark = false,
  className = "",
}) {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.2,
  });

  const alignClasses = {
    left: "text-left",
    center: "text-center mx-auto",
    right: "text-right ml-auto",
  };

  return (
    <div
      ref={ref}
      className={`max-w-3xl mb-12 lg:mb-16 ${
        alignClasses[align]
      } ${className} ${inView ? "animate-fade-in" : "opacity-0"}`}
    >
      {label && (
        <span
          className={`inline-block text-sm font-medium tracking-wider uppercase mb-4 ${
            dark ? "text-brand-accent" : "text-brand-accent"
          }`}
        >
          {label}
        </span>
      )}
      {title && (
        <h2
          className={`font-heading text-h2 md:text-display-2 ${
            dark ? "text-white" : "text-brand-primary"
          }`}
        >
          {title}
        </h2>
      )}
      {subtitle && (
        <p
          className={`mt-4 text-body-lg ${
            dark ? "text-white/70" : "text-text-secondary"
          }`}
        >
          {subtitle}
        </p>
      )}
    </div>
  );
}
